<template>
  <div v-if="lot.currency && !(isLotSold || isLotUnsold) && lot.auction && ['both', 'bid_only'].indexOf(lot.auction.purchase_type) > -1" class="ta-lot-view-max-bid">
    <bidding-max-bid-modal />
    <div class="ta-lot-view-max-bid-inner">
      <div class="ta-lot-view-max-bid-wrapper">
        <a href="javascript:void(0)" id="change-max-bid-button"
           v-b-tooltip:hover
           @click="showMaxBidModal" class="btn-link text-sm">
          {{ lot.max_bid ? $t('Change your max bid') : $t('Set your max bid') }}
        </a>
        <small v-if="lot.max_bid" class="ta-lot-view-current-max-bid"> - {{ lot.max_bid | asCurrency(lot.currency.code) }}</small>
      </div>
      <small class="ta-lot-view-number-of-bids">{{ lot.num_of_bids || 0 }} {{ $t('bids') }}</small>
      <b-tooltip v-if="biddingFinished" target="change-max-bid-button" container="artisioTimedAuctions">
        {{ $t('Lot has ended') }}
      </b-tooltip>
    </div>
  </div>
</template>

<script>
import maxBidMixin from "../../../mixins/maxBidMixin";
import {mapActions, mapState} from "vuex";
import lotBiddingMixin from "../../../mixins/lotBiddingMixin";
import UpcomingAmountPopover from "../../lot-view/UpcomingAmountPopover";
import TaxRateAndPremiums from "@/components/TaxRateAndPremiums";
import CalculatedPremium from "@/components/lot-view/CalculatedPremium.vue";
import BidAmount from "@/components/lot-view/BidAmount.vue";
import BidTotalAmount from "@/components/lot-view/BidTotalAmount.vue";
import MaxBidForm from "@/components/configuration/lot-list-item/MaxBidForm.vue";
import BiddingMaxBidModal from "@/components/configuration/lot-bidding/BiddingMaxBidModal.vue";

export default {
  name: "BiddingMaxBid",
  components: {
    BiddingMaxBidModal,
    MaxBidForm,
    BidTotalAmount,
    BidAmount,
    CalculatedPremium,
    TaxRateAndPremiums,
    UpcomingAmountPopover
  },
  mixins: [maxBidMixin, lotBiddingMixin],
  data: () => ({
    maxBidAmount: '',
    maxBidState: null,
    errorMessage: null,
  }),
  computed: {
    ...mapState(['mainConfig']),
    ...mapState({
      maxBidModal: state => state.lotObject.maxBidModal
    })
  },
  methods: {
    ...mapActions(['createMaxBid', 'deleteMaxBid']),
  }
}
</script>

<style lang="scss">
#artisioTimedAuctions {
  #max-bid-modal {
    .modal-footer {
      justify-content: space-between;
    }
  }
  .ta-lot-view-max-bid-inner {
    display: flex;
    justify-content: space-between;
  }
  .ta-lot-view-max-bid-wrapper {
    display: flex;
    align-items: center;
  }
  .ta-lot-view-current-max-bid{
    margin-left: 0.25rem;
  }
}
</style>
